import { conversationTimelineQueryOptions } from "@features/conversations/timeline"
import { createFileRoute, notFound } from '@tanstack/react-router'
import { studentConversationsQueryOptions } from '@features/conversations/queries'
import { Conversation } from '@features/conversations/components/Conversation'

export const Route = createFileRoute('/_layout/students/$studentNo/conversations/$conversationId')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>): { messageId?: number } => {
        const id = Number(search.messageId)
        return { messageId: Number.isSafeInteger(id) && id > 0 ? id : undefined }
    },
    loader: async ({ params, context }) => {
        const [, conversations] = await Promise.all([
            context.queryClient.ensureQueryData(conversationTimelineQueryOptions(params.conversationId)),
            context.queryClient.ensureQueryData(studentConversationsQueryOptions({ studentNo: params.studentNo })),
        ])
        const conversation = conversations.find((conversation) => conversation.idConversation === Number(params.conversationId))
        if (!conversation) {
            throw notFound();
        }
        return conversation
    },
    staticData: {
        crumb: {
            dynamicLabel: (match)  => `#${match.params.conversationId}`
        }
    }
})

function RouteComponent() {
    const conversation = Route.useLoaderData()
    const { studentNo } = Route.useParams()
    const { messageId } = Route.useSearch()

    return (
        <Conversation conversation={conversation} studentNo={studentNo} targetMessageId={messageId} />
    )
}
